/** Planned articles — placeholders until posts are written and published. */
export const ARTICLES = [
  { category: "Getting started", title: "What to prepare before you build a small business website", excerpt: "Logos, photos, copy and the decisions worth making before a designer starts." },
  { category: "Local search", title: "Setting up your Google Business Profile the right way", excerpt: "The fields that matter, the photos to add, and how to keep hours accurate." },
  { category: "Restaurants", title: "Why your menu shouldn't be a PDF", excerpt: "How a mobile-friendly menu helps hungry visitors decide faster." },
  { category: "Conversion", title: "Five places to put your phone number", excerpt: "Small layout choices that make it easier for customers to call you." },
  { category: "Hosting", title: "What website maintenance actually involves", excerpt: "Updates, backups, security and the small edits that keep a site healthy." },
  { category: "Redesign", title: "Signs it's time to redesign your website", excerpt: "How to tell if your current site is costing you customers." },
];

export const CHECKLIST_PREVIEW = [
  "Business basics: name, services, service area, hours",
  "Brand assets: logo files, colors, fonts",
  "Photos: team, location, work samples",
  "Pages you need and what each should do",
  "Calls to action: call, book, request a quote",
  "Domain, email and access details",
  "Local SEO basics and Google Business Profile",
];
